import React, { useMemo, useState } from 'react'
import moment from 'moment-timezone';
import { useParams } from 'react-router-dom';
import { MilestoneStep } from 'types/campaign/collaborations';
import { submitStepDeadline } from 'services/api/campaign/collaboration';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import inModal from 'utils/hoc/inModal';
import { useGetAgencyTimezone } from 'slices/auth/selector';

interface DeadlineCalendarProps {
    isActive: boolean,
    onClose: (refetch?: boolean) => void,
    step: MilestoneStep
}

const DeadlineCalendar: React.FC<DeadlineCalendarProps> = ({ step, onClose }) => {

    const [date, setDate] = useState('');

    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);
    const agencyTimezone = useGetAgencyTimezone();
    const agencyTz = agencyTimezone?.iana_code;
    const { campaignId, collaborationId } = useParams();

    const getISOString = () => {
        if (!date) return null;
        const formattedDate = agencyTz
            ? moment.tz(date, ['YYYY-MM-DDTHH:mm', 'YYYY-MM-DDTHH:mm:ss'], true, agencyTz)
            : moment(date, ['YYYY-MM-DDTHH:mm', 'YYYY-MM-DDTHH:mm:ss'], true);
        return formattedDate.isValid() ? formattedDate.toISOString() : null;
    };

    const submitDeadline = async () => {

        const dateTime = getISOString();

        if (!dateTime || !campaignId || !selectedAgencyId || !collaborationId) return;
        try {
            await submitStepDeadline(selectedAgencyId, campaignId, collaborationId, step.gig_step.slug, dateTime)
            onClose(true);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className='w-100'>
            <div className='w-100 d-flex justify-content-center align-items-center text-dark date-time-wheel p-3'>
                <input type='datetime-local' className='form-control' value={date} onChange={(e) => setDate(e.target.value)} />
            </div>
            <div className="milestone-step-actions px-3">
                <button onClick={() => submitDeadline()} className="theme-btn theme-btn-primary w-100">Submit</button>
            </div>
        </div>
    )
}


const DeadlineCalendarModal: React.FC<DeadlineCalendarProps> = (props) => {
    const title = `Add Deadline`

    const ModalComponent = useMemo(() => inModal(DeadlineCalendar, title), [title])
    return <ModalComponent {...props} />
}


export default DeadlineCalendarModal;
